export default "__VITE_ASSET__DQiGx6zx__"